import { Timestamp } from "firebase/firestore";
import Transaction from "../models/Transaction";
import { useEffect, useState } from "react";
import {getTransactionsOverTime} from "../_util/TransactionUtilities";

const NextMonthIncome = ({transactions}: {transactions: Transaction[], canEdit: boolean, settings?: {[x: string]: any}}) => {
    const [totalIncome, setTotalIncome] = useState(0);

    useEffect(() => {
        const incomes = transactions.filter((transaction) => transaction.type === "income");
        const start = new Date();
        const end = new Date(start.getFullYear(), start.getMonth() + 1, start.getDate());
        const transactionsOverTime = getTransactionsOverTime(incomes, start, end);
        let totalIncome = transactionsOverTime.reduce((acc, transaction) => {
            return acc + transaction.amount;
        }, 0);
        setTotalIncome(totalIncome);
    }, [transactions]);

    return (
        <div className="widget" style={{height: "100%", boxSizing: "border-box",}}>
            <h2 className="widget-title" style={{fontSize: 20, margin: 0, display: "flex", justifyContent: "start", alignItems: "center", gap: 15}}>Expected Income</h2>
                <div className="widget-content" style={{marginTop: 12}}>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h2 style={{margin: 0}}>{totalIncome.toLocaleString("nl-NL", {style: "currency", currency: "EUR"})}</h2>
                    <p style={{fontSize: "0.8em"}}>Next Months Income</p>
                </div>
            </div>
        </div>
    );
};

export default [NextMonthIncome, {w: 2, h: 1}, {}] as const;